import { Platform } from 'root/src/shared/@types/platforms';
/**
 * Returns platform URL by platform and mnemonicId
 * https://www.twitch.tv/${mnemonicId}
 * https://www.youtube.com/channel/${mnemonicId}
 * https://www.tiktok.com/@${mnemonicId}
 */
export function getChannelUrlByPlatform({ platform, mnemonicId }) {
    switch (platform) {
        case Platform.Twitch:
            return `https://www.twitch.tv/${mnemonicId}`;
        case Platform.YouTube:
            return `https://www.youtube.com/channel/${mnemonicId}`;
        case Platform.TikTok:
            return `https://www.tiktok.com/@${mnemonicId}`;
        default:
            return undefined;
    }
}
